var map = {
	"./Debande.webp": "293f",
	"./Khalid.webp": "8c71",
	"./Yousef.webp": "822f",
	"./Yousuf.webp": "67cb",
	"./banner.webp": "b16c",
	"./banner1-mb.webp": "2c49",
	"./banner1.webp": "3d96",
	"./bg-fr-mb.webp": "1884",
	"./bg-frame-mb.webp": "cd7a",
	"./confetty.webp": "19bd",
	"./double.webp": "1519",
	"./frame-768.webp": "bb94",
	"./frame-992.webp": "7f2f",
	"./frame-mb.webp": "bbbe",
	"./frame.webp": "bcb4",
	"./green-certificate-and-seed.webp": "5416",
	"./introduce.webp": "518d",
	"./match-3.webp": "4b21",
	"./match-4.webp": "01b7",
	"./match-5.webp": "c2df",
	"./match-6.webp": "6117",
	"./match-7.webp": "26be",
	"./number1.webp": "ee15",
	"./number2.webp": "43ec",
	"./number3.webp": "1e93",
	"./om.webp": "9d5d",
	"./people-frame-mb.webp": "c12b",
	"./people-frame.webp": "fc84",
	"./person-frame-mb.webp": "f462",
	"./person-frame.webp": "6070",
	"./prize-frame.webp": "6c2e",
	"./rec.webp": "6b09",
	"./rectangle.webp": "e4c4",
	"./single.webp": "85ef",
	"./sub-frame.webp": "36dc",
	"./view-live.webp": "aa8f",
	"./winner.webp": "bb2b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9366";